import { render, staticRenderFns } from "./StationSensorsCard.vue?vue&type=template&id=2bc3ce1f&scoped=true&"
import script from "./StationSensorsCard.vue?vue&type=script&lang=js&"
export * from "./StationSensorsCard.vue?vue&type=script&lang=js&"
import style0 from "./StationSensorsCard.vue?vue&type=style&index=0&id=2bc3ce1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc3ce1f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VIcon,VSelect,VSimpleTable,VTextField,VTooltip})
